import { BooleanOperation } from '~/engine/util/algorithms/sdf/SDFOperations';

/** How the panel names, describes and writes one boolean operation. */
interface BooleanOperationText {
    nameId: string;
    /** Message id of what it keeps, with inputs `{left}` and `{right}`. */
    descriptionId: string;
}

/** The operations in the order the menu lists them. */
export const BOOLEAN_OPERATIONS = [
    BooleanOperation.OR,
    BooleanOperation.AND_NOT,
    BooleanOperation.AND,
    BooleanOperation.XOR,
] as const;

export const BOOLEAN_OPERATION_TEXT: Record<
    BooleanOperation,
    BooleanOperationText
> = {
    [BooleanOperation.OR]: {
        nameId: 'booleanOperations.op.or',
        descriptionId: 'booleanOperations.op.or.description',
    },
    [BooleanOperation.AND_NOT]: {
        nameId: 'booleanOperations.op.not',
        descriptionId: 'booleanOperations.op.not.description',
    },
    [BooleanOperation.AND]: {
        nameId: 'booleanOperations.op.and',
        descriptionId: 'booleanOperations.op.and.description',
    },
    [BooleanOperation.XOR]: {
        nameId: 'booleanOperations.op.xor',
        descriptionId: 'booleanOperations.op.xor.description',
    },
};

/**
 * The letter that names an input of the chain: A for the base, then B, C
 * and on for each step, continuing AA, AB after Z.
 */
export function inputLetter(index: number): string {
    let letter = '';
    for (let n = index; n >= 0; n = Math.floor(n / 26) - 1) {
        letter = String.fromCharCode(65 + (n % 26)) + letter;
    }
    return letter;
}
